import { createClient } from "@supabase/supabase-js";

// Create React App exposes env vars prefixed with REACT_APP_ to the browser.
// The anon key is DESIGNED to be public and shipped in the client — it is
// protected by your Row Level Security policies. Never put the service_role
// key here or in any REACT_APP_ variable.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // Surfaces clearly in the browser console if env vars are missing after deploy.
  console.error(
    "[MumHQ] Missing Supabase config. Set REACT_APP_SUPABASE_URL and " +
      "REACT_APP_SUPABASE_ANON_KEY in your .env (local) and in your host's " +
      "environment variables (deployment), then rebuild."
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true, // keep users signed in across refreshes / app relaunch
    autoRefreshToken: true, // refresh the session token silently
    detectSessionInUrl: true, // handle the email-confirmation redirect
  },
});
